import axios from 'axios';
import comprimirImagen from './comprimirImagen';

/**
 * Compresión de imágenes en TODA la plataforma, en un solo punto: antes de enviar cualquier petición
 * de axios con FormData, cada foto de más de 1.5 MB se reduce a máx. 2048 px y ~1.5 MB.
 *  - No toca PDF, XML, Excel, videos, GIF ni lo que ya sea ligero (comprimirImagen lo deja igual).
 *  - Las pantallas que ya comprimen con su propia medida (Avance de obra, Tickets, Parrillas) mandan
 *    archivos chicos y pasan sin cambios.
 *  - Rutas EXCLUIDAS (la imagen original importa): material de la empresa / clientes (logos, renders,
 *    tipografía), firma del perfil, plantillas PPTX y catálogo de planos, e.firma del SAT.
 *  - Una petición puede pedir que no se toque con la opción { sinComprimir: true } de axios.
 */
const UMBRAL = 1.5 * 1024 * 1024;
const OPCIONES = { maxSizeMB: 1.5, maxWidthOrHeight: 2048 };
const EXCLUIDAS = [
    'mercadotecnia/material', // material-clientes, material-empresas y la biblioteca v3 de materiales
    'users/firma',
    'pptx', 'plantilla', 'catalogo-planos',
    'efirma',
    'logo',
];

const excluida = (url = '') => EXCLUIDAS.some((p) => String(url).toLowerCase().includes(p));
const esFormData = (d) => typeof FormData !== 'undefined' && d instanceof FormData;
const esFotoPesada = (v) => typeof File !== 'undefined' && v instanceof File && v.size > UMBRAL
    && /^image\/(jpeg|jpg|png|webp|bmp|heic|heif)$/i.test(v.type || '');

export async function comprimirFormData(fd) {
    const entradas = Array.from(fd.entries());
    if (!entradas.some(([, v]) => esFotoPesada(v))) return fd; // nada que comprimir: misma instancia
    const nuevo = new FormData();
    for (const [k, v] of entradas) {
        if (esFotoPesada(v)) {
            // eslint-disable-next-line no-await-in-loop
            const { archivo } = await comprimirImagen(v, OPCIONES);
            nuevo.append(k, archivo, archivo.name);
        } else if (typeof File !== 'undefined' && v instanceof File) {
            nuevo.append(k, v, v.name);
        } else {
            nuevo.append(k, v);
        }
    }
    return nuevo;
}

let instalado = false;
export default function instalarCompresionGlobal(instancia = axios) {
    if (instalado) return;
    instalado = true;
    instancia.interceptors.request.use(async (config) => {
        if (!config || config.sinComprimir || !esFormData(config.data) || excluida(config.url)) return config;
        try { config.data = await comprimirFormData(config.data); } catch (_) { /* si algo falla se manda tal cual */ }
        return config;
    });
}
